"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bulb = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Bulb = function Bulb() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.803 8.4a8.4 8.4 0 00-8.4-8.4h-.144a8.52 8.52 0 00-8.256 8.088 8.4 8.4 0 003.696 7.2 2.4 2.4 0 011.104 2.088V18a1.2 1.2 0 001.2 1.2h4.8a1.2 1.2 0 001.2-1.2v-.624a2.4 2.4 0 011.092-2.016 8.4 8.4 0 003.708-6.96zm-5.052 4.968a4.8 4.8 0 00-1.8 2.232h-3.096a4.897 4.897 0 00-1.812-2.232 6 6 0 01-2.64-5.196A6.144 6.144 0 0112.295 2.4h.108a6 6 0 013.348 10.968zm-5.4 9.78a1.2 1.2 0 01-.348-.84V21.6h4.8v.708a1.2 1.2 0 01-.348.84l-.504.504a1.2 1.2 0 01-.84.348h-1.416a1.2 1.2 0 01-.84-.348l-.504-.504z",
    clipRule: "evenodd"
  });
};

exports.Bulb = Bulb;